export * from './skyscraper4.component';